import { render } from "./CadastroConclusao.vue?vue&type=template&id=dbf6d510&scoped=true&lang=html"
const script = {}

import "./CadastroConclusao.vue?vue&type=style&index=0&id=dbf6d510&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf6d510"]])

export default __exports__